<template>
  <div
    class="session-more-questions"
    data-ui="more-questions-section"
  >
    <h3
      class="session-more-questions__title"
      data-ui="more-questions-section-title"
    >
      Have more questions?
    </h3>
    <CdrText
      tag="p"
      data-ui="more-questions-section-description"
    >
      Visit our
      <CdrLink
        href="/events/resources/faqs"
        rel="nofollow"
        target="_blank"
        @click="() => handleClick('FAQs')"
      >
        FAQs
      </CdrLink>
      or contact us at
      <CdrLink
        :href="firstContactChannel.href"
        data-ui="more-questions-section-first-channel"
        @click="() => handleClick(sessionOnlyHasPhoneNumber ? 'phone' : 'email')"
      >
        {{ firstContactChannel.display }}
      </CdrLink>
      <template v-if="sessionIsFromTrekAndHasEmailAndPhoneNumber">
        or
        <CdrLink
          :href="secondContactChannel.href"
          data-ui="more-questions-section-phone"
          @click="() => handleClick('phone')"
        >
          {{ secondContactChannel.display }}
        </CdrLink>
      </template>
      <span>{{ '.' }}</span>
    </CdrText>
  </div>
</template>

<script>
import { CdrLink, CdrText } from '@rei/cedar';
import metrics from '../mixins/metrics';

export default {
  name: 'SessionMoreQuestionsComponent',
  components: {
    CdrLink,
    CdrText,
  },
  mixins: [metrics],
  props: {
    /**
     * Session values
     */
    operatorEmail: {
      type: String,
      default: null,
    },
    operatorPhoneNumber: {
      type: String,
      default: null,
    },
    fromTrek: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    defaultEmailProps() {
      return {
        href: `mailto:experiences@rei.com`,
        display: 'experiences@rei.com',
      };
    },
    sessionOnlyHasPhoneNumber() {
      return !this.operatorEmail && this.operatorPhoneNumber;
    },
    sessionIsFromTrekAndHasEmailAndPhoneNumber() {
      return this.operatorEmail && this.operatorPhoneNumber && this.fromTrek;
    },
    firstContactChannel() {
      if (!this.fromTrek) {
        return this.defaultEmailProps;
      }
      if (this.operatorEmail) {
        return {
          href: `mailto:${this.operatorEmail}`,
          display: this.operatorEmail,
        };
      }
      if (this.operatorPhoneNumber) {
        return this.formatPhoneNumber(this.operatorPhoneNumber);
      }
      return this.defaultEmailProps;
    },
    secondContactChannel() {
      if (this.sessionIsFromTrekAndHasEmailAndPhoneNumber) {
        return this.formatPhoneNumber(this.operatorPhoneNumber);
      }
      return {};
    },
  },
  methods: {
    formatPhoneNumber(phoneNumber) {
      const formattedPhoneNumber = phoneNumber.replace('(', '').replace(')', '-');
      const splitPhoneNumber = formattedPhoneNumber.split('-');
      return {
        href: `tel:+1-${formattedPhoneNumber}`,
        display: `1 (${splitPhoneNumber[0]}) ${splitPhoneNumber[1]}-${splitPhoneNumber[2]}`,
      };
    },
    handleClick(str) {
      const linkName = `{{ pageName }}:SessionMoreQuestions_${str}_link`;
      this.metricsClick({ linkName });
    },
  },
};
</script>
